"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Microphone = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 17,
  height: 14,
  viewBox: "0 0 17 14"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M0.53217 0.530217C0.239277 0.82311 0.239277 1.29798 0.53217 1.59088L1.55768 2.61638C1.42323 2.75671 1.30914 2.91673 1.21983 3.09202C1.00184 3.51984 1.00184 4.0799 1.00184 5.2V8.8C1.00184 9.92011 1.00184 10.4802 1.21983 10.908C1.41157 11.2843 1.71753 11.5903 2.09386 11.782C2.52168 12 3.08173 12 4.20184 12H8.80184C9.81305 12 10.3678 12 10.7809 11.8396L12.1356 13.1943C12.4285 13.4872 12.9033 13.4872 13.1962 13.1943C13.4891 12.9014 13.4891 12.4265 13.1962 12.1336L1.59283 0.530217C1.29994 0.237324 0.825063 0.237324 0.53217 0.530217ZM12.0018 8.8L12.0018 8.93921L5.06261 2H8.80184C9.92194 2 10.482 2 10.9098 2.21799C11.2861 2.40973 11.5921 2.71569 11.7839 3.09202C12.0018 3.51984 12.0018 4.0799 12.0018 5.2V8.8ZM13.0018 8.93864V5.05246L16.6685 3.02175C16.824 2.95625 17.0018 3.04354 17.0018 3.21825V10.7728C17.0018 10.9475 16.824 11.0566 16.6685 10.9693L13.0018 8.93864Z",
  className: "fill"
}));
var _default = exports.default = Microphone;